export const dAppUrl = 'https://mint.notoriousrugs.io'